<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="fabricRequestCode"
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width: 100px; height: 66px"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.fabricRequestStatus === 'Y'
              ? 'success'
              : row.fabricRequestStatus === 'P'
              ? 'warning'
              : ['D', 'B'].includes(row.fabricRequestStatus)
              ? 'danger'
              : ''
          "
        >
          {{ row.v_fabricRequestStatus }}
        </el-tag>
      </template>
      <template v-slot:isInStock="{ row }">
        <el-tag
          size="mini"
          :type="row.isInStock === 'Y' ? 'success' : 'danger'"
        >
          {{
            row.isInStock === 'Y'
              ? $l('table_label_isInStock_Y') || '已入库'
              : $l('table_label_isInStock_N') || '未入库'
          }}
        </el-tag>
      </template>
      <template v-slot:widAndWeight="{ row }">
        <span>{{ row.wid }} {{ row.widUnit }}</span>
        <br />
        <span>{{ row.fabricWeight }} {{ row.fabricWeightUnit }}</span>
      </template>
      <template v-slot:priceInfo="{ row }">
        <span>
          {{ row.unitPrice }} {{ $l('table_label_unitPriceUnit') || '元' }}/
          {{ row.fabricUnit }}
        </span>
      </template>
      <template v-slot:displayCreate="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:displayModify="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { fabricRequestCode, fabricRequestNo } = data
      if (!menuType) return

      switch (menuType) {
        case 'detail':
        case 'edit':
          this.$emit('openEditPage', {
            pageType: menuType,
            params: { fabricRequestCode },
            query: { fabricRequestNo },
          })
          break
        case 'delete':
          this.del(data)
          break
        case 'apply':
          this.apply(data)
          break
        case 'printer':
          this.printer(data)
          break
        default:
          console.error('menuType configuration error:', menuType)
      }
    },
    async del({ fabricRequestCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .fabricRequestDelApi({ fabricRequestCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async apply({ fabricRequestCode, fabricAgentCode }) {
      if (fabricAgentCode != this.userInfo.userCode) {
        this.$message.warning(
          this.$l('tips_warning_apply') ||
            '当前数据业务员与操作人与不一致，请修改后重试'
        )
        return
      }
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_question_audit') || '是否审核?',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .fabricRequestOaDevelopApplyApi({
          fabricRequestCode,
          linkUrl: this.$joinURL(`/opview/fabricrequest/${fabricRequestCode}`, {
            joinOrigin: true,
            joinBasePath: false,
          }),
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_submission_failed'))
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_Submitted_successfully'),
        type: 'success',
      })
      this.$emit('reload')
    },
    printer({ fabricRequestCode }) {
      this.$api.globalExportData(
        '/digitalCenter/fabric/request/print',
        { fabricRequestCode },
        '面料开发申请单'
      )
    },
  },
}
</script>
